import { Pipe, PipeTransform } from '@angular/core';
/*
 * Masks the value
 * Usage:
 *   value | maskValue
 * Example 1:
 *   {{ 'jayan.patel.osv@fedex.com' | maskValue }}
 *   formats to: 'ja***@f***.com'
 * Example 2:
 *   {{ '1234567890' | maskValue }}
 *   formats to: '***-***-7890'
 */
@Pipe({
    name: 'maskValue',
    pure: true,
    standalone: false
})

export class MaskValuePipe implements  PipeTransform {
    transform(value: string): string {
        const maskedValue = value ? (value?.includes('@') ? this.maskEmail(value) : this.maskPhone(value)) : '';
        return maskedValue;
    }
    maskEmail(val: string): string {
        const index = val.lastIndexOf('@');
        const masked = `${val.slice(0,2)}***${val.substring(index, index + 2)}***${val.slice(-4)}`;
        return masked;
    }
    maskPhone(val: string): string {
        const masked = `***-***-${val.slice(-4)}`;
        return masked;
    }
}
